import { TableCell } from '@mui/material';

// row for the bulk pay period table: shows the rebate name and its current pay period
const RebatePayPeriodTableRow = ({ row, tableHeader }) => {
    return (
        <>
            {tableHeader.map(el =>
                <TableCell key={el['columnname']}>{row[el['columnname']] || '-'}</TableCell>
            )}
        </>
    );
}

export default RebatePayPeriodTableRow;
